import { FC } from "react";
import { Button, ButtonVariant, Modal } from "shared/components";
import { InfoCircle } from "untitledui-js-base";

type Props = {
  opened: boolean;
  onClose: () => void;
  handleUnsubscribe: () => void;
};

export const UnsubscribeModal: FC<Props> = ({
  opened,
  onClose,
  handleUnsubscribe
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="p-6 flex flex-col items-center max-w-[366px] border border-alpha-100"
    >
      <div className="bg-danger-50 rounded-full p-4 mb-4">
        <InfoCircle className="stroke-danger-500" size="32" />
      </div>
      <h3 className="text-content-1000 font-bold text-xl mb-2">
        Unsubscribe renter?
      </h3>
      <p className="text-content-500 font-base text-center mb-4">
        You are about to unsubscribe the renter from BoomReport. The renter will
        no longer be reported.
      </p>
      <div className="flex gap-2 w-full">
        <div className="w-full">
          <Button className="w-full" onClick={onClose}>
            Cancel
          </Button>
        </div>
        <div className="w-full">
          <Button
            className="w-full"
            variant={ButtonVariant.PRIMARY}
            onClick={handleUnsubscribe}
          >
            Unsubscribe
          </Button>
        </div>
      </div>
    </Modal>
  );
};
